(function ($) {
    var ready_class = 'is-ready',
        abort_class = 'is-aborted',
        done_class = 'is-done';

    var LoadingBar = (function ($) {

        LoadingBar = function (options) {
            var that = this;

            // DOM
            that.$wrapper = $('<div />', {class: 'loading-bar', id: 'loading-bar'});
            that.$bar = $('<div />', {class: 'bar'}).appendTo(that.$wrapper);
            that.top = (options['top'] || '0px');
            that.hide_time = 200;

            // VARS
            that.timeout = 0;
            that.is_rendered = false;

            // INIT
            that._init();
        };

        LoadingBar.prototype._init = function () {
            var that = this;

            that.$wrapper.css('top', that.top);
        };

        /**
         * @param {Number?} percent
         * */
        LoadingBar.prototype.show = function (percent) {
            var that = this,
                $body = $('body');

            clearTimeout(that.timeout);
            that.$bar.css('transition', '');

            percent = (typeof percent === 'number' ? percent : 0);

            that.set(percent);

            that.$wrapper.removeClass([abort_class, done_class].join(' '));
            that.$wrapper.appendTo($body);
            that.$wrapper[0].offsetHeight;
            that.$wrapper.addClass(ready_class);

            that.is_rendered = true;
        };

        LoadingBar.prototype.hide = function () {
            var that = this,
                fade_time = (that.hide_time < 200 ? 0 : that.hide_time);

            that.$wrapper.removeClass(ready_class);
            that.$bar.css('transition', '');

            clearTimeout(that.timeout);
            that.timeout = setTimeout(function () {
                that.$wrapper
                    .detach()
                    .removeClass([abort_class, done_class].join(' '));

                that.set(0);
                that.is_rendered = false;
            }, fade_time);
        };

        /**
         * @param {Number} percent
         * */
        LoadingBar.prototype.set = function (percent) {
            var that = this;

            percent = (typeof percent === 'number' ? percent : 0);

            if (percent >= 0) {
                percent = (percent > 100 ? 100 : percent);
                that.$bar.width(percent + '%');
            }
        };

        LoadingBar.prototype.animate = function (time, percent, close) {
            var that = this;

            time = (typeof time === 'number' ? time : 4000);
            percent = (typeof percent === 'number' ? percent : 100);
            close = (typeof close === 'boolean' ? close : true);

            that.show();
            that.$bar.css('transition', 'width ' + time + 'ms ease-out');
            that.set(percent);

            clearTimeout(that.timeout);
            that.timeout = setTimeout(function () {
                if (close) {
                    that.done();
                }
            }, time);
        };

        LoadingBar.prototype.done = function () {
            var that = this;

            if (!that.is_rendered) {
                return
            }

            clearTimeout(that.timeout);
            that.$wrapper.addClass(done_class);
            that.$bar.css('transition', 'width ' + that.hide_time + 'ms ease-out');
            that.set(100);
            
            setTimeout(function () {
                that.hide();
            }, that.hide_time + 100);
        };

        LoadingBar.prototype.abort = function () {
            var that = this;

            if (!that.is_rendered) {
                return false;
            }

            clearTimeout(that.timeout);
            that.$wrapper.addClass(abort_class);
            that.$bar.css('transition', 'width ' + that.hide_time + 'ms ease-out');
            that.set(100);

            setTimeout(function () {
                that.hide();
            }, that.hide_time + 100);
        };

        return LoadingBar;

    })($);

    $.uiLoadingBar = function (options) {
        options = (typeof options === 'object' ? options : {});
        return new LoadingBar(options);
    };
})(jQuery);